import {CategoryAssociationModel} from '../../../shared/models/category-association.model';
import {CategoryAssociationsService} from '../../../shared/services/category-associations.service';
import {Component, OnInit, Input} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-category-association-new',
  templateUrl: './category-association-new.component.html',
  styleUrls: ['./category-association-new.component.css']
})
export class CategoryAssociationNewComponent implements OnInit {

  category: CategoryAssociationModel = new CategoryAssociationModel();
  pageForm: FormGroup;

  constructor(public activeModal: NgbActiveModal, private formBuilder: FormBuilder,
    private service: CategoryAssociationsService) {
    this.pageForm = this.formBuilder.group({
      'name': ['', Validators.required],
      'description': ['', Validators.required]
    });

  }

  ngOnInit() {}

  pageSubmit(): void {
    (<any>Object).assign(this.category, this.pageForm.value);
    this.service.create(this.category, this.pageForm.value.category)
      .subscribe(data => this.activeModal.close('assoc-modal-success'), err => console.log(err));
  }

}
